import renderSiteSearch from "../actions/renderSiteSearch";
/**
 * 404 Page
 */
const Page404 = ($) => {
	if ($("main").hasClass("page-404")) {
		renderSiteSearch();
	}
};

export default Page404;
